/* import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

 class TextValidator extends ValidatorComponent {
    renderValidatorComponent() {   
        const { errorMessages, validators, requiredError, validatorListener, ...rest } = this.props;

        return (
            <div>
                <input
                    {...rest}
                    ref={(r) => { this.input = r; }}
                />
                {this.errorText()}
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div style={{ color: 'red' }}>
                {this.getErrorMessage()}
            </div>
        );
    }
}

export default TextValidator; */


import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

class TextValidator extends ValidatorComponent {

    renderValidatorComponent() {   
        const { isIgAddOn, inputGroupAddOn, errorMessages, tooltip, validators, label, isRemoveFg, hideLabel, requiredError, isRequired, infotext, withRequiredValidator, validatorListener, ...rest } = this.props;
        const { isValid } = this.state;
        if (isIgAddOn)
        {
            return (
                <div className={(isRemoveFg ? "inline-input" : "form-group") + (isValid ? "" : " has-error")}>
                    {hideLabel ? null : (<label>{label} {tooltip} {isRequired ? (<span className="text-danger">*</span>) : ''}</label>)}
                    <div className="input-group">
                    <input className="form-control"
                        {...rest}
                        ref={(r) => { this.input = r; }}/>
                    {inputGroupAddOn} 
                    </div>
                    {infotext && !this.errorText() ? <small className="text-muted">{infotext}</small> : ""}
                    {this.errorText()}
                </div >
            );
        }

        else
        {
            return (
                <div className={(isRemoveFg ? "inline-input" : "form-group") + (isValid ? "" : " has-error")}>
                    {hideLabel ? null : (<label>{label} {tooltip} {isRequired ? (<span className="text-danger">*</span>) : ''}</label>)}
                <input className="form-control"
                    {...rest}
                    ref={(r) => { this.input = r; }}
                />
                {infotext && !this.errorText() ? <small className="text-muted">{infotext}</small> : ""}
                {this.errorText()}
            </div >);
        }
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <span className="help-block">
                {this.getErrorMessage()}
            </span>
        );
    }
}

export default TextValidator;


// WEBPACK FOOTER //
// ./src/components/shared/textvalidator.js